import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                VTabs,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [_c(VTab, [_vm._v("General")])],
                1
              ),
              _c(
                VTabsItems,
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "b-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h6", [_vm._v("Original")]),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.organization"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.objOriginDs.organization,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objOriginDs,
                                                  "organization",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objOriginDs.organization",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.operator"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.objOriginDs.data_operator,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objOriginDs,
                                                  "data_operator",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objOriginDs.data_operator",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.domain"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VSelect, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              items: _vm.selectDomain,
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.objOriginDs.kdomain,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objOriginDs,
                                                  "kdomain",
                                                  $$v
                                                )
                                              },
                                              expression: "objOriginDs.kdomain",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.subdomain"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VSelect, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              items: _vm.selectSubdomain,
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.objOriginDs.ksubdomain,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objOriginDs,
                                                  "ksubdomain",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objOriginDs.ksubdomain",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.sensitive"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VCheckbox, {
                                            attrs: {
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.objOriginDs.sensitive_data,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objOriginDs,
                                                  "sensitive_data",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objOriginDs.sensitive_data",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.environment"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.objOriginDs.environment,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objOriginDs,
                                                  "environment",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objOriginDs.environment",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.description"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextarea, {
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "no-resize": "",
                                              "hide-details": "",
                                              rows: "3",
                                            },
                                            model: {
                                              value:
                                                _vm.objOriginDs
                                                  .object_description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objOriginDs,
                                                  "object_description",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objOriginDs.object_description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h6", [
                                    _vm._v(
                                      _vm._s(_vm.$t("my_tasks.modals.request"))
                                    ),
                                  ]),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.organization"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: {
                                              resaltador:
                                                _vm.diffRequest.organization,
                                            },
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.objRequestDs.organization,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objRequestDs,
                                                  "organization",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objRequestDs.organization",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.operator"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: {
                                              resaltador:
                                                _vm.diffRequest.data_operator,
                                            },
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.objRequestDs.data_operator,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objRequestDs,
                                                  "data_operator",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objRequestDs.data_operator",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.domain"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VSelect, {
                                            class: {
                                              resaltador:
                                                _vm.diffRequest.kdomain,
                                            },
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              items: _vm.selectDomain,
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.objRequestDs.kdomain,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objRequestDs,
                                                  "kdomain",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objRequestDs.kdomain",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.subdomain"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VSelect, {
                                            class: {
                                              resaltador:
                                                _vm.diffRequest.ksubdomain,
                                            },
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              items: _vm.selectSubdomain,
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.objRequestDs.ksubdomain,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objRequestDs,
                                                  "ksubdomain",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objRequestDs.ksubdomain",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.sensitive"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VCheckbox, {
                                            class: {
                                              resaltador:
                                                _vm.diffRequest.sensitive_data,
                                            },
                                            attrs: {
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.objRequestDs.sensitive_data,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objRequestDs,
                                                  "sensitive_data",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objRequestDs.sensitive_data",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.environment"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextField, {
                                            class: {
                                              resaltador:
                                                _vm.diffRequest.environment,
                                            },
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              "hide-details": "",
                                              disabled: "",
                                            },
                                            model: {
                                              value:
                                                _vm.objRequestDs.environment,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objRequestDs,
                                                  "environment",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objRequestDs.environment",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VRow,
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        VCol,
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            VSubheader,
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "my_tasks.modals.description"
                                                  )
                                                ) + ":"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCol,
                                        [
                                          _c(VTextarea, {
                                            class: {
                                              resaltador:
                                                _vm.diffRequest
                                                  .object_description,
                                            },
                                            attrs: {
                                              dense: "",
                                              filled: "",
                                              disabled: "",
                                              "no-resize": "",
                                              "hide-details": "",
                                              rows: "3",
                                            },
                                            model: {
                                              value:
                                                _vm.objRequestDs
                                                  .object_description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.objRequestDs,
                                                  "object_description",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "objRequestDs.object_description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("hr"),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "sm",
                                label: "Request reason",
                              },
                            },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  filled: "",
                                  dense: "",
                                  size: "sm",
                                  rows: "3",
                                  "max-rows": "3",
                                  type: "text",
                                  "no-resize": "",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.item.commentary,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "commentary", $$v)
                                  },
                                  expression: "item.commentary",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showFooter
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "sm",
                                    label: "Message to reply",
                                  },
                                },
                                [
                                  _c(VTextarea, {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      size: "sm",
                                      rows: "3",
                                      "max-rows": "3",
                                      type: "text",
                                      "no-resize": "",
                                    },
                                    model: {
                                      value: _vm.response_text,
                                      callback: function ($$v) {
                                        _vm.response_text = $$v
                                      },
                                      expression: "response_text",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12", lg: "12" } },
                        [
                          _c(
                            "b-alert",
                            {
                              attrs: {
                                show: _vm.dismissCountDown,
                                dismissible: "",
                                variant: "danger",
                              },
                              on: {
                                dismissed: function ($event) {
                                  _vm.dismissCountDown = 0
                                },
                                "dismiss-count-down": _vm.countDownChanged,
                              },
                            },
                            [
                              _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                              _c("b-progress", {
                                attrs: {
                                  variant: "danger",
                                  max: _vm.dismissSecs,
                                  value: _vm.dismissCountDown,
                                  height: "4px",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }